import { render, staticRenderFns } from "./CouponPackageTab.vue?vue&type=template&id=6d1ed71a"
import script from "./CouponPackageTab.vue?vue&type=script&lang=js"
export * from "./CouponPackageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1ed71a')) {
      api.createRecord('6d1ed71a', component.options)
    } else {
      api.reload('6d1ed71a', component.options)
    }
    module.hot.accept("./CouponPackageTab.vue?vue&type=template&id=6d1ed71a", function () {
      api.rerender('6d1ed71a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/couponPackage/CouponPackageTab.vue"
export default component.exports